import { nanoid } from "nanoid"
import { customAlphabet } from "nanoid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { ServiceType } from "../../active/constants/serviceType"
import { EngagementType } from "../../active/constants/engagementType"
import { SupplierNewArgs } from "../args/supplierNewArgs"
import { UserModel } from "@/modules/users/models/userModel"
import { UserManagerModel } from "@/modules/users/models/userManagerModel"
import { ProposalBaseModel } from "../proposalBaseModel"
import { HiringLocation } from "./hiringLocation"
import { SubAreaModel } from "@/modules/prices/models/subAreaModel"
import { SupplierListView } from "../../supplier/models/supplierListView"
import { RFQExtended } from "../args/rfqExtended"
import {
  ArrayMinSize,
  IsArray,
  IsEnum,
  IsNotEmpty,
  ValidateNested,
} from "class-validator"

const generateId = customAlphabet("0123456789abcdefghijklmnopqrstuvwxyz", 12)

@Serializable
export class RFSConsultantModel extends ProposalBaseModel {
  @IsEnum(ServiceType, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  serviceType: ServiceType.Consultant = ServiceType.Consultant
  @IsEnum(EngagementType, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  engagementType: EngagementType = EngagementType.TimeAndMaterial
  projectName: string = ""
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  justification: string = ""
  requestId: string = generateId()
  @ValidateNested({
    groups: ["rfs"],
  })
  costCenterId: string = ""
  costCenterName: string = ""
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  locations: HiringLocation[]
  @ValidateNested({
    groups: ["rfs"],
  })
  @ArrayMinSize(1, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  selectedSubAreas: SubAreaModel[]
  distributeTo: SupplierListView[]
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  newSuppliers: SupplierNewArgs[]
  requester: UserModel
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  approvers: UserManagerModel[]
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  managers: UserManagerModel[]
  hourlyrateApprovers: UserManagerModel[]
  periodApprovers: UserManagerModel[]
  extended: RFQExtended | null

  constructor(init?: Partial<RFSConsultantModel>) {
    super(init)
    this.locations = init?.locations || []
    this.selectedSubAreas = init?.selectedSubAreas || []
    this.distributeTo = init?.distributeTo || []
    this.newSuppliers = init?.newSuppliers || []
    this.requester = init?.requester || new UserModel()
    this.approvers = init?.approvers || []
    this.hourlyrateApprovers = init?.hourlyrateApprovers || []
    this.periodApprovers = init?.periodApprovers || []
    this.managers = init?.managers || []
    this.extended = init?.extended || null
    Object.assign(this, init)
  }
}
